import { render } from "./ui-list-view.vue?vue&type=template&id=36b8a8a3&scoped=true&ts=true"
import script from "./ui-list-view.vue?vue&type=script&lang=ts"
export * from "./ui-list-view.vue?vue&type=script&lang=ts"

import "./ui-list-view.vue?vue&type=style&index=0&id=36b8a8a3&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b8a8a3"]])

export default __exports__